import FullScreenLoader from "../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getBasicPropertydetails, PropertyLoginApi } from "../Services/Service";


const PropertyLogin = () => {
  const navigate = useNavigate();
  const [Username, setUsername] = useState("");
  const [Password, setPassword] = useState("");
  // const [showPassword, setShowPassword] = useState(false);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loader
    setError("");

    try {
      const result = await PropertyLoginApi(Username, Password);
      if (result?.token) {

        localStorage.setItem("PropertyUsername", Username);
        localStorage.setItem("PropertyPassword", Password);
        localStorage.setItem("PropertyAuthToken", result.token);
        localStorage.setItem("authType", "property");

        // Save PropertyID
        const payload = JSON.parse(atob(result.token.split(".")[1]));
        if (payload?.PropertyID) {
          localStorage.setItem("PropertyID", payload.PropertyID);
        }

        const propertyData = await getBasicPropertydetails();
        if (propertyData && propertyData.length > 0) {
          localStorage.setItem("PropertyName", propertyData[0].PropertyName);
        }

        navigate("/Property/Dashboard");
      } else {
        setError("Invalid login credentials");
      }
    } catch (err) {
      setError("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          .form-control{
            border-color: #D3D3D4 !important;
          }
             .text-danger{
                 color: #ff000d !important;
            }
                  .input-error {
            border-color: red !important;
          }
        `}
      </style>

      {loading && (
        <FullScreenLoader />
      )}

      <div className="login-wrapper d-flex">
        {/* Left Panel */}
        <div className="login-left ">

          <h2 className="fw-bold ">Welcome back!</h2>
          <p className="text-muted mb-1 ">User Experience & Interface Design</p>
          <p className="text-muted ">Strategy SaaS Solutions</p>
          <img
            src="/assets/img/login-bg.png"
            alt="login"
            className="img-fluid mt-5 "
            style={{ maxWidth: '220px' }}
          />
        </div>

        {/* Right Panel */}
        <div className="login-right">
          <div className="login-box w-100">
            <h3 className="text-center fw-bold mb-4">Sign in your Property account</h3>
            <form className="mt-3" onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="form-label">Username/Email</label>
                <input
                  type="text"
                  className={`form-control ${error ? "input-error" : ""}`}
                  placeholder="Enter your username"
                  value={Username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className={`form-control ${error ? "input-error" : ""}`}
                  placeholder="Enter your password"
                  value={Password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="text-end mb-3">
                <Link href="/Forgotpassword" className="text-primary">Forgot password?</Link>
              </div>
              {/* Show error message if login fails */}
              {error && <div className="text-danger text-center">{error}</div>}
              <button type="submit" className="btn btn-primary w-100 fw-bold">Sign In</button>
            </form>

          </div>
        </div>
      </div>


    </>
  );
};

export default PropertyLogin;
